<p-table #dt [value]="filteredOrders" [tableStyle]="{ 'min-width': '60rem' }" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="150vh" currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}" [globalFilterFields]="['code', 'name', 'channel', 'status.description']">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <h2>Órdenes</h2>
        <!-- <h5 class="m-0">Buscar Comercios</h5> -->
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input pInputText type="text" (input)="onInput($event)" placeholder="Busqueda Rápida" />
        </p-iconfield>
      </div>
    </ng-template>
    <ng-template #header>
        <tr>
            <th pSortableColumn="code" style="width:20%">Código <p-sortIcon field="code" /></th>
            <th pSortableColumn="name" style="width:20%">Cliente <p-sortIcon field="name" /></th>
            <th pSortableColumn="date" style="width:20%">Fecha <p-sortIcon field="date" /></th>
            <th pSortableColumn="channel" style="width:20%">Canal <p-sortIcon field="channel" /></th>
            <th pSortableColumn="amount" style="width:20%">Monto <p-sortIcon field="amount" /></th>
            <th pSortableColumn="status" style="width:20%">Estado <p-sortIcon field="status" /></th>
            <th pSortableColumn="actions" style="width:20%"></th>
        </tr>
    </ng-template>
    <ng-template #body let-order>
        <tr>
            <td>{{ order.code }}</td>
            <td>{{ order.name }}</td>
            <td>{{ order.date }}</td>
            <td>{{ order.channel }}</td>
            <td>{{ order.amount | currency:currency:'symbol-narrow':'1.2-2' }}</td>
            <td>
                <div class="flex items-center gap-2">
                    <div class="inline-block min-w-[110px] max-w-[180px] text-center">
                        <!-- <span 
                            class="inline-block min-w-[110px] max-w-[180px] text-center whitespace-normal break-words px-2 py-1 text-xs leading-tight rounded-xl"
                            [ngClass]="order.status.color" variant="outlined">
                            {{ order.status.description }}
                        </span> -->
                        <p-tag variant="outlined" [severity]="order.status.color" [value]="order.status.description" [rounded]="true"></p-tag>
                    </div>
                </div>
            </td>
            <td>
                <p-splitbutton label="Acciones" [model]="orderOptions" outlined severity="info" />
            </td>
        </tr>
    </ng-template>
</p-table>
